import { render, staticRenderFns } from "./tts.vue?vue&type=template&id=0753e22a&scoped=true&"
import script from "./tts.vue?vue&type=script&lang=js&"
export * from "./tts.vue?vue&type=script&lang=js&"
import style0 from "./tts.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./tts.vue?vue&type=style&index=1&id=0753e22a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0753e22a",
  null
  
)

export default component.exports